<div class="modal-content d-flex flex-column">
  <div class="section-title apm-text-red text-break d-flex align-items-center">
    <apm-fa-icon class="me-2" icon="warning" size="md"></apm-fa-icon>{{ resourceIds.title | apmTranslate }}
  </div>
  <hr class="gray-divider-1 mb-3" />
  <div class="mb-2">{{ resourceIds.infoDescription | apmTranslate: [count] }}</div>
  <div class="mb-4">{{ resourceIds.infoHint | apmTranslate }}</div>
  <div class="d-flex flex-row justify-content-between mt-3">
    <apm-button variant="secondary" (click)="close()" additionalClass="px-5">{{
      resourceIds.cancel | apmTranslate
    }}</apm-button>
    <apm-button variant="primary" (click)="goToWpl()" additionalClass="px-5">{{
      (isWplRoute ? resourceIds.confirm : resourceIds.goToWpl) | apmTranslate
    }}</apm-button>
  </div>
</div>
